import * as yup from 'common/yup';

export const ExportPgpPublicPayload = yup.object({
   keyID: yup.idString(),
   asciiArmored: yup.bool(),
   filePath: yup.string(),
   overwrite: yup.bool(),
});

export const ExportPgpSecretPayload = ExportPgpPublicPayload.shape({
   passphrase: yup.string(),
});

export const ExportSshPublicPayload = yup.object({
   keyID: yup.idString(),
   filePath: yup.string(),
   overwrite: yup.bool(),
});

export const ExportSshSecretPayload = ExportSshPublicPayload.shape({
   passphrase: yup.string(),
});
